import { Button, Card, Text } from '@payaca/ambrosia';
import { getBrandingColourContext } from '@payaca/helpers/brandingColourContextHelper';
import UntitledIcon from '@payaca/untitled-icons';
import { CSSProperties, FC } from 'react';

type Props = {
  brandColour: string | null;
};

const BrandColourPreview: FC<Props> = (props) => {
  const { brandColour } = props;

  const context = getBrandingColourContext(brandColour || undefined);
  const jobBrandStyle = {
    '--job-context-brand-colour': context.brandColour,
    '--job-context-lighter-brand-colour': context.lightBrandColour,
    '--job-context-darker-brand-colour': context.darkerBrandColour,
    '--job-context-readable-text-brand-colour': context.brandReadableTextColour,
    '--job-context-brand-colour-l10': context.brandColourL10,
    '--job-context-brand-colour-l95': context.brandColourL95,
  } as CSSProperties;

  return (
    <div style={jobBrandStyle} className="w-full max-w-sm">
      <Card sizeVariant="sm" className="bg-white">
        <Card.Body className="flex flex-col gap-4">
          <Text level="supporting">
            This is how your brand colour looks to customers in the client
            portal — on proposals and invoices.
          </Text>
          <div className="flex flex-wrap gap-2">
            <Button colour="job-brand" size="sm" tabIndex={-1} aria-hidden>
              Accept
            </Button>
            <Button
              colour="job-brand"
              variant="secondary"
              size="sm"
              tabIndex={-1}
              aria-hidden
            >
              View
            </Button>
            <Button
              colour="job-brand"
              variant="quaternary"
              size="sm"
              tabIndex={-1}
              aria-hidden
            >
              Decline
            </Button>
          </div>
          <div className="border-l-job-brand bg-job-brand-l95 text-job-brand-l10 flex items-center gap-2 rounded-lg border-l-4 p-3">
            <UntitledIcon className="text-job-brand" name="file-02" />
            <Text as="span">Proposal #1001</Text>
          </div>
          <Text level="supporting">
            It also tints your team&apos;s Field App, and carries through to
            proposals and estimates signed on-site.
          </Text>
        </Card.Body>
      </Card>
    </div>
  );
};

export default BrandColourPreview;
